var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loggedIn)?_c('div',[_c('nav-bar'),_c('aside-menu',{attrs:{"menu":_vm.menu}}),_c('router-view'),_c('logout-modal')],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }